import React, { useState, useEffect } from "react";

const JobPost = () => {
  const [careerData, setCareerData] = useState([]);

  useEffect(() => {
    fetch("rawData/careerData.json")
      .then((res) => res.json())
      .then((data) => setCareerData(data));
  }, []);
  return (
    <>
      <div className="row" >
        {careerData.map((item) => (
          <div className="col-md-6">
            <div className="career" style={{marginBottom:10}}>
              <h3>{item.jobName}</h3>
              <h4>Location : {item.location} </h4>
              <p>{item.description}</p>
              {/*  <a  class="btn-link pop" >APPLY NOW  <i class="circle circle--right icon-right-open"></i></a> */}
              <div className="form-group">
                <form className="subscribe-form" data-toggle="validator">
                  <div className="row">
                    <div className="col-12" style={{ textAlign: "center" }}>
                      <a id="open-popup2" className="btn2">
                        {/* <a href="mailto:career@dmtca.com" class="btn-link" >*/}
                        APPLY NOW
                        <i className="circle circle--right icon-right-open" />
                      </a>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default JobPost;
